import { MissingComponentWarning } from "core/MissingComponentWarning";
import React from "react";
import { objectPropertiesToArray } from "../utils/utils";
import { ComponentTypeMappings } from "./component-mappings";
import { ComponentTypeWithID, IComponentType, IComponentTypeMapping } from "./ComponentTypeTypes";
import { DashboardComponentType, DashboardComponentTypeBase } from "../api/model/dashboard/DashboardComponent";

export function loadComponentModule(type: DashboardComponentType) {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't map unknown component type: ${type}`);
    return <MissingComponentWarning componentId={type as string} />;
  }
  return ComponentTypeMappings[type as keyof IComponentTypeMapping].entryPoint();
}

export function getComponentType(type: DashboardComponentTypeBase): IComponentType | undefined {
  if (!(type in ComponentTypeMappings)) {
    return undefined;
  }

  return ComponentTypeMappings[type];
}

export function getDashboardComponentTypes(): ComponentTypeWithID[] {
  return objectPropertiesToArray(ComponentTypeMappings).filter(
    type => type.dashboardComponent
  ) as ComponentTypeWithID[];
}
